import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';
import {FetcherService} from '@core/services/fetcher.service';
import {Api} from '@core/models/api.enum';
import {IUser, NewPassword, Notis} from '@core/models/user';
import {InitLoaders} from '@core/models/init-loaders';
import {map, tap} from 'rxjs/operators';
import {NbToastrService} from '@nebular/theme';


@Injectable({
    providedIn: 'root'
})
export class UserService extends InitLoaders {

    private user$: BehaviorSubject<IUser> = new BehaviorSubject(null);

    constructor(private fetcher: FetcherService,
                private toastr: NbToastrService) {
        super();
    }

    get getUser$(): Observable<IUser> {
        if (!!this.user$.getValue()) {
            return this.user$;
        }
        return this.fetcher.get<IUser>(Api.user)
            .pipe(map((user) => {
                this.setUser = user;
                return user;
            }));
    }

    set setUser(user: IUser) {
        this.user$.next(user);
    }

    changePassword(form: NewPassword, id: number) {
        return this.showLoaderUntilCompleted(this.fetcher.put(Api.changePassword, form, {id}), 'changePassword')
            .pipe(tap((res: any) => this.toastr.success('', 'Пароль успешно изменен')));
    }

    getNotis(): Observable<Notis[]> {
        // this.fetcher.get('i-need-a-money', {}, null, {headers: {'x-id-header': '3'}}).subscribe();
        return this.showLoaderUntilCompleted(this.fetcher.get(Api.notifications), 'getNotis');
    }

    clearNotis(): Observable<Notis[]> {
        return this.showLoaderUntilCompleted(this.fetcher.get(Api.notificationsClean), 'clearNotis');
    }

    readNotis(): Observable<Notis[]> {
        return this.showLoaderUntilCompleted(this.fetcher.get(Api.notificationsRead), 'readNotis');
    }

}
